import useScript from '@charlietango/use-script'
import { useEffect, useState } from 'react'
import { lesewebApi } from '../config/leseweb'
import { subscribe, unsubscribe, dispatch } from './dispatcher'

let initialized = false

const setLesewebEventHandler = () => {
  window.vFact_HTML5Player.setEventHandler_OnChangePlaylistStatus(
    newPlaylistStatus => {
      dispatch('playlistStatusChange', newPlaylistStatus)
    },
  )
  initialized = true
}

// make sure the iFrame-leseweb is ready before setting the custom event handler
const initializeStatusMonitor = i => {
  if (i > 10) return
  setTimeout(() => {
    const iFrame = document.getElementById('vFact_audioFrame')
    if (
      iFrame &&
      iFrame.contentWindow.vFactDetect2 &&
      window.vFact_HTML5Player &&
      window.vFact_HTML5Player.setEventHandler_OnChangePlaylistStatus
    ) {
      setLesewebEventHandler()
    } else if (i < 10) {
      initializeStatusMonitor(i + 1)
    }
  }, 200 + i * 500)
}

/**
 * useReadAloudStatus
 * hook to get status of the read aloud-module (leseweb).
 * manually subscribe/unsubribe to the event (see dispatcher)
 */

export default function useReadAloudStatus() {
  const [ready, status] = useScript(lesewebApi)
  const [lesewebInitialized, setLesewebInitialized] = useState(false)
  const [isReadingAloud, setIsReadingAloud] = useState(status === 1)

  useEffect(() => {
    if (ready) {
      if (!initialized) {
        initializeStatusMonitor(0)
      }

      setLesewebInitialized(true)
      const playlistStatus = newPlaylistStatus => {
        // playlist play status was changed!
        if (newPlaylistStatus === 0) {
          // playing has stopped
          setIsReadingAloud(false)
          return
        } else {
          // playing has started
          setIsReadingAloud(true)
        }
      }
      subscribe('playlistStatusChange', playlistStatus)

      return () => {
        unsubscribe('playlistStatusChange', playlistStatus)
      }
    }
  }, [ready])

  return { isReadingAloud, lesewebInitialized }
}



// WEBPACK FOOTER //
// ./src/hooks/useReadAloudStatus.js